import React, { useState } from 'react';
import { FaAmazon } from 'react-icons/fa';
import { SiTwilio } from 'react-icons/si';
import { GiMountaintop } from "react-icons/gi";

const messagingServices = [
  { 
    name: 'Twilio', 
    icon: SiTwilio, 
    description: 'Messaging platform',
    subDescription: 'Send reports to patients, doctors, and clients'
  },
  { 
    name: 'Pinnacle', 
    icon: GiMountaintop, 
    description: 'Messaging platform',
    subDescription: 'Send reports to patients, doctors, and clients'
  },
  { 
    name: 'AWS', 
    icon: FaAmazon, 
    description: 'Messaging platform',
    subDescription: 'Send reports to patients, doctors, and clients'
  }
];

const MessagingCard = ({ name, Icon, description, subDescription, isActive, onClick }) => (
  <div 
    className={`tw-bg-white tw-rounded-lg tw-p-6 tw-shadow-md tw-transition-all tw-duration-300 hover:tw-shadow-lg tw-cursor-pointer
      ${isActive ? 'tw-border-2 tw-border-[#03335b] tw-bg-[#03335b]/10' : 'tw-border tw-border-gray-200'}`}
    onClick={onClick}
  >
    <div className="tw-flex tw-items-start">
      <div className="tw-w-20 tw-h-20 tw-bg-gray-100 tw-rounded-md tw-flex tw-items-center tw-justify-center tw-mr-4 tw-flex-shrink-0">
        <Icon className="tw-text-[#03335b] tw-text-5xl" />
      </div>
      <div>
        <h3 className="tw-text-xl tw-font-bold tw-text-[#03335b] tw-mb-2">{name}</h3>
        <p className="tw-text-sm tw-text-gray-600 tw-mb-1">{description}</p>
        <p className="tw-text-sm tw-text-gray-600">{subDescription}</p>
      </div>
    </div>
  </div>
);

const Messaging = () => {
  const [activeService, setActiveService] = useState(0); // Default to Twilio (index 0)

  return (
    <div className="tw-bg-white tw-rounded-lg tw-p-8 tw-m-4 tw-shadow-lg">
      <p className="tw-text-gray-600 tw-mb-6">
        Integrating messaging services helps the platform send SMS to users for various communications, including reports and notifications.
      </p>
      <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-6">
        {messagingServices.map((service, index) => (
          <MessagingCard
            key={service.name}
            name={service.name}
            Icon={service.icon}
            description={service.description}
            subDescription={service.subDescription}
            isActive={index === activeService}
            onClick={() => setActiveService(index)}
          />
        ))}
      </div>
    </div>
  );
};

export default Messaging;